module.exports = __webpack_public_path__ + "Gold-8eb7d2afcfac24b2b59cf0382d27d5a6.png";